export function stickyHeader(element: HTMLElement): void {
  const height = element.clientHeight;

  let prevScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  let prevScrollDirection = '';


  const scrollFunc = () => {

    const st = window.scrollY;
    if (st > prevScrollTop && prevScrollDirection !== 'down') {
      // downscroll code here
      element.classList.add('hidden');
    }
    else if (st < prevScrollTop && prevScrollDirection !== 'up') {
      // upscroll code
      element.classList.remove('hidden');
    }
    prevScrollTop = st <= 0 ? 0 : st; // for Mobile or negative scrolling
  };

  window.addEventListener('scroll', scrollFunc, { passive: true, capture: true });
  window.addEventListener('touchstart', scrollFunc, { passive: true, capture: true });
  window.addEventListener('touchmove', scrollFunc, { passive: true, capture: true });
  window.addEventListener('touchend', scrollFunc, { passive: true, capture: true });
}